// AUTOGENERATED BY FUNCTION genubamodel.js
export interface CommandBase {
    id: string;
    eventCorrelationId: string;
    jobId?: string;
    producerId: string;
    sequenceId?: number;
    version: number;
    type: string;
    created: string;
    createdBy: string;
    createdById: string;
}

export interface EntityBase {
    id?: string;
    parentId?: string;
    parentType?: ParentType;
    version?: number;
    created?: string;
    createdBy?: string;
    createdById?: string;
    updated?: string;
    updatedBy?: string;
    updatedById?: string;
    currentState?: string;
    lastTransition?: string;
    externalWorkflowId?: string;
    eventNotes?: string;
    transactionLockId?: string;
}

export interface AccountCommand extends CommandBase {
    data?: Account;
}

export interface BankAccountCommand extends CommandBase {
    data?: BankAccount;
    clientId?: string;
}

export interface BenefitAccountCommand extends CommandBase {
    data?: BenefitAccount;
    clientElection?: Election;
    individualElection?: Election;
}

export interface PersonBenefitAccountFeatureRestrictionCommand extends CommandBase {
    data?: PersonBenefitAccountFeatureRestriction;
    additionalProperties?: AdditionalPBAFRProperties;
}

export interface DependentBenefitAccessCommand extends CommandBase {
    data?: DependentBenefitAccess;
}

export interface EntryCommand extends CommandBase {
    data?: Entry;
    claimedFundsDisbursement?: ClaimedFundsDisbursement;
}

export interface EntriesCommand extends CommandBase {
    data?: CRUDEntriesCommandData;
}

export interface PaymentSourceCommand extends CommandBase {
    data?: PaymentSource;
    clientId?: string;
}

export interface PostingCommand extends CommandBase {
    data?: Posting;
}

export interface ScheduledPostingsActionCommand extends CommandBase {
    data?: ScheduledPostingsAction;
}

export interface InterestPostingCommand extends CommandBase {
    data?: InterestPosting;
}

export interface InvestmentContributionPostingCommand extends CommandBase {
    data?: InvestmentContributionPosting;
}

export interface ProcessSettlementCommand extends CommandBase {
    data?: ProcessSettlement;
}

export interface ProcessCABFundingCommand extends CommandBase {
    data?: ProcessCABFunding;
}

export interface RecalculateBenefitAccountCommand extends CommandBase {
    data?: RecalculateBenefitAccount;
}

export interface ScheduleAdjustmentsCommand extends CommandBase {
    data?: ScheduleAdjustments;
}

export interface ElectionCommand extends CommandBase {
    data?: Election;
}

export interface TradeCommand extends CommandBase {
    data?: Trade;
}

export interface InvestmentBalanceCommand extends CommandBase {
    data?: InvestmentBalance;
}

export interface Address {
    id?: string;
    addressType?: AddressType;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    country?: string;
    zip?: string;
    zipplusfour?: string;
}

export interface Account extends EntityBase {
    profileId: string;
    profileType: ProfileType;
    bureau?: string;
    accountType: AccountType;
    paymentSourceId?: string;
    primaryPath?: string;
    secondaryPath?: string;
    startDateTime?: string;
    endDateTime?: string;
    externalAccountId?: string;
}

export interface AccountPosting extends Posting {
    externalAccountId?: string;
    transactionDateTime?: string;
    accountType?: string;
    balancingAccountType?: string;
    methodType?: PostingMethodType;
    description?: string;
    paymentStatus?: PaymentStatusType;
}

export interface BankAccount extends EntityBase {
    name?: string;
    accountType?: BankAccountType;
    bankName?: string;
    routingNumber?: string;
    accountNumber?: string;
    paymentAccountType: PaymentAccountType;
    cardType?: CardType;
    token?: string;
    lastFour?: string;
    expirationDate?: string;
    address?: Address;
    addressOwnerType?: AddressOwnerType;
    paymentOwnerName?: string;
    useForFees?: boolean;
    useForFunding?: boolean;
    investmentTradingPartnerId?: string;
    investmentIndividualId?: string;
    investmentPlanId?: string;
    paymentVendor?: PaymentVendor;
}

export interface BenefitAccount extends EntityBase {
    clientId: string;
    planId: string;
    planName: string;
    planDescription?: string;
    planStartDate: string;
    planEndDate?: string;
    hireDate: string;
    benefitEffectiveDate: string;
    eligibilityEndDate?: string;
    clientLastScheduleDate?: string;
    individualLastScheduleDate?: string;
    requestTypes?: RequestTypes;
    soaAccountId?: string;
    balance?: number;
    carryoverDeclined: boolean;
    approvedBy?: string;
    approvedDate?: string;
    payrollScheduleId?: string;
    excludeFromBilling: boolean;
    cashAccountMinimumBalance?: number;
    enrollmentSource?: EnrollmentSourceType;
    clientScheduleFirstDate?: string;
    individualScheduleFirstDate?: string;
    scheduleEndDate?: string;
    lastDayToSubmitExpenses?: string;
    coverageTier?: BenefitPlanCoverageType;
    reasonToHoldDisbursements?: string;
    finalCoverageDate?: string;
    fullCoveragePaidThroughDate?: string;
    scheduleChangeDate?: string;
    disbursableDate?: string;
    participantTerminationType?: ParticipantTerminationType;
    hideFrom?: HideFromType;
    optForCobraCoverage?: boolean;
    inactivationDate?: string;
    inactivationReason?: BenefitAccountInactivationReasonType;
    lossOfCoverageOverride?: boolean;
    bypassDepletionOrder?: boolean;
    planType?: string;
    cardGroupId?: string;
    xpsProfileId?: string;
    terminatedDueToDivisionTransfer?: boolean;
}

export interface DependentBenefitAccess extends EntityBase {
    benefitAccountId: string;
    eligibilityStartDate: string;
    eligibilityEndDate?: string;
    inactivationDate?: string;
}

export interface ClaimedFundsDisbursement {
    disbursementMethod: DisbursementMethodType;
    externalCardToken?: string;
    paymentSourceId?: string;
}

export interface InterestPosting extends EntityBase {
    bureauId?: string;
    startDate?: string;
    endDate?: string;
    amount?: string;
    intendedAmount?: string;
    totalEntriesPublished?: number;
    totalEntriesEntered?: number;
    totalEntriesErrored?: number;
}

export interface InvestmentContributionPosting extends EntityBase {
    bureauId?: string;
    scheduledDate?: string;
    currentContributionDrawId?: string;
}

export interface ProcessSettlement extends EntityBase {
    externalId?: string;
    paymentDetails?: EntryPaymentDetails;
    isFundingSettlement?: boolean;
}

export interface ProcessCABFunding extends EntityBase {
    clientId?: string;
    benefitPlanId?: string;
    scheduledDate?: string;
    clientCABFundingId?: string;
    fundingSourceType?: FundingSourceType;
}

export interface RecalculateBenefitAccount extends EntityBase {
    fundingSourceType: FundingSourceType;
    planStartDate: string;
    electionChange?: boolean;
    fundingSourceAndScheduleId: string;
    electionEffectiveDate?: string;
    individualId?: string;
}

export interface ScheduleAdjustments extends EntityBase {
    electionChange?: boolean;
    manualAdjustment?: boolean;
    fundingSourceAndScheduleId: string;
    adjustments: ScheduleAdjustment[];
}

export interface ScheduleAdjustment {
    scheduleType?: ScheduleType;
    scheduledDate: string;
    amount: number;
}

export interface Election extends EntityBase {
    electionProfileType: ElectionProfileType;
    electionScheduleType: ElectionScheduleType;
    amount?: number;
    proratedAmount?: number;
    effectiveDate: string;
    contributionScheduleEffectiveDate?: string;
    deductionScheduleEffectiveDate?: string;
    fundingScheduleEffectiveDate?: string;
    qualifyingLifeEvent?: string;
    excessContributionAmount?: number;
    bypassEnabled?: boolean;
    bypassReason?: string;
    coverageTier?: BenefitPlanCoverageType;
    calculationMethod: ElectionCalculationMethod;
}

export interface BenefitAccountLimitedBalance {
    balance?: number;
    balanceType?: BalanceType;
    isCarryover?: boolean;
    fundingAmount?: number;
    disbursementAmount?: number;
}

export interface BenefitAccountBalance extends BenefitAccount {
    balance?: number;
}

export interface OperationalAccountBalance {
    profileId?: string;
    operationalAccountProfileType?: OperationalAccountProfileType;
    profileName?: string;
    balance?: number;
    accountId?: string;
    accountType?: AccountType;
}

export interface PaymentSourceAccount extends PaymentSource {
    paymentAccountType?: PaymentAccountType;
    accountType?: BankAccountType;
    cardType?: CardType;
    lastFour?: number;
    expirationDate?: string;
    bankAccountName?: string;
    paymentOwnerName?: string;
    investmentTradingPartnerId?: string;
    investmentIndividualId?: string;
    investmentPlanId?: string;
    address?: Address;
    addressOwnerType?: AddressOwnerType;
    bankAccountNumber?: string;
}

export interface BenefitAccountElection extends BenefitAccount, Election {
    electionId?: string;
    electionCurrentState?: ElectionState;
    electionTransactionLockId?: string;
}

export interface BenefitAccountEntryEx extends Entry {
    benefitAccount_id?: string;
    benefitAccount_parentId?: string;
    benefitAccount_parentType?: BenefitAccountParentType;
    benefitAccount_currentState?: string;
    clientId?: string;
    planId?: string;
    planName?: string;
    planCurrentState?: string;
    planStartDate?: string;
    planEndDate?: string;
    offeringName?: string;
    fullName?: string;
    primaryEmail?: string;
    individualExternalId?: string;
    individualCurrentState?: string;
    electionProfileType?: ElectionProfileType;
    electionScheduleType?: ElectionScheduleType;
    pendingElectionAmount?: number;
    activeElectionAmount?: number;
    fundingPosting?: FundingPostingType;
    postingMethod?: PostingMethodType;
    autopostDelayedScheduledDate?: string;
}

export interface BenefitAccountPostingSummary {
    availableBalance?: number;
    totalContributionsToDate?: number;
    totalDisbursementsToDate?: number;
    totalPriorYearContributions?: number;
    totalCurrentYearContributions?: number;
}

export interface BenefitElectionSchedule extends EntityBase {
    postingDates?: string[];
    amounts?: number[];
    remainingDates?: string[];
    postingScheduleType?: PostingScheduleType;
    entryStates?: string[];
}

export interface BenefitElectionScheduleCriteria {
    clientId?: string;
    planId: string;
    benefitAccountId?: string;
    payrollScheduleId?: string;
    individualScheduleFirstDate?: string;
    clientScheduleFirstDate?: string;
    individualElectionAmount?: number;
    clientElectionAmount?: number;
    fundingSourceType?: FundingSourceType;
    scheduleType?: ScheduleType;
    effectiveDate?: string;
}

export interface BenefitElectionSourceAndSchedules {
    fundingSourceType: FundingSourceType;
    fundingSchedule: BenefitElectionSchedule;
    contributionSchedule: BenefitElectionSchedule;
    deductionSchedule?: BenefitElectionSchedule;
}

export interface ClientAchSettlement {
    entryId: string;
    amount: number;
    transactionDateTime: string;
    bankAccountName?: string;
    bankAccountNumber?: string;
    paymentSourceId: string;
    currentState?: string;
    startDateTime: string;
    endDateTime: string;
    sourceParentId?: string;
    parentType: ParentType;
    entryType: EntryType;
    paymentSourceType: PaymentSourceType;
    paymentOwnerName?: string;
    paymentDetails?: EntryPaymentDetails;
    bankAccountParentId?: string;
}

export interface PersonBenefitAccountFeatureRestriction extends EntityBase {
    benefitAccountId?: string;
    benefitPlanOrFeatureId: string;
    benefitPlanOrFeatureType: BenefitPlanOrFeatureType;
    benefitEffectiveDate?: string;
    eligibilityEndDate?: string;
    restrictRequests: boolean;
    restrictCard: boolean;
    restrictCardEditableByUser: boolean;
    xpsProfileId: string;
}

export interface Entry extends EntityBase {
    externalId?: string;
    scheduledDate?: string;
    startDateTime?: string;
    endDateTime?: string;
    transactionDateTime?: string;
    memo?: string;
    isManualCorrection?: boolean;
    override?: boolean;
    allowedRecalculationType?: AllowedRecalculationType;
    entryType?: EntryType;
    type?: string;
    eventSource?: EventSourceType;
    correlationId?: string;
    amount?: number;
    soaData?: EntrySOAData;
    fundingSource?: FundingSourceType;
    postingScheduleType?: PostingScheduleType;
    parentReversalId?: string;
    linkId?: string;
    scheduleManually?: boolean;
    paymentSourceId?: string;
    taxYear?: string;
    postings?: Postings;
    bureauId?: string;
    externalDocumentId?: string;
    isSetToBeRetroactive?: boolean;
    payeeId?: string;
    paymentDetails?: EntryPaymentDetails;
    invoiceNumber?: string;
    deferScheduledDate?: string;
}

export interface EntryPaymentUpdateView extends Entry {
    entryId?: string;
    benefitAccountId?: string;
    benefitPlanId?: string;
    benefitPlanPaymentSourceId?: string;
}

export interface EntryPosting {
    id?: string;
    parentId?: string;
    parentType?: ParentType;
    entryType?: string;
    scheduledDate?: string;
    deferScheduledDate?: string;
    accountId?: string;
    profileId?: string;
    entryState?: string;
    amount?: number;
    postingType?: string;
    transactionDateTime?: string;
    paymentDetails?: EntryPaymentDetails;
    accountType?: AccountType;
    transferNote?: string;
}

export interface EntrySOAData {
    advanceFeatureId?: string;
    advanceLimit?: number;
    amountToDisburse?: number;
    benefitPlanId?: string;
    bureauBin?: string;
    cashFeatureId?: string;
    clientId?: string;
    endDate?: string;
    frequency?: FrequencyType;
    individualId?: string;
    newParticipantAdvanceFundingId?: string;
    startDate?: string;
    thresholdAmount?: number;
    soaEntryType?: SoaEntryType;
    sourceBenefitPlanId?: string;
    targetBenefitPlanId?: string;
    investedBalance?: number;
    minimumTradeAmount?: number;
    balanceThreshold?: number;
    dependentId?: string;
    holdingAccountDescriptorId?: string;
    destinationHoldingAccountDescriptorId?: string;
    payeeId?: string;
    clientCauseId?: string;
    bureauId?: string;
}

export interface EntryPaymentDetails {
    benefitPlanId?: string;
    checkDate?: string;
    checkNumber?: string;
    transactionId?: string;
    paymentId?: string;
    payeeId?: string;
    planName?: string;
    payeeName?: string;
    dateReceived?: string;
    amountReceived?: number;
    externalMemo?: string;
    paymentSourceType?: PaymentSourceType;
    cabFundingPaymentSummary?: CabFundingPaymentSummary;
    paymentAccountGroupName?: string;
    disputeAmount?: number;
    chargebackEntryId?: string;
    obligationId?: string;
    obligationLineItemId?: string;
    paymentPlanId?: string;
    subType?: EntrySubType;
    rejectReason?: string;
    feeLinkId?: string;
    charityId?: string;
    charityName?: string;
    financialProcessor?: FinancialProcessor;
}

export interface CabFundingPaymentSummary {
    clientCABFundingId?: string;
    cabFundingPaymentDetails?: CabFundingPaymentDetail[];
}

export interface CabFundingPaymentDetail {
    planId?: string;
    planName?: string;
    scheduledDate?: string;
    amountSum?: number;
}

export interface EntrySummary {
    entryType?: EntryType;
    planId?: string;
    currentState?: string;
    scheduledDate?: string;
    amountSum?: number;
}

export interface EntryPlan {
    entryId?: string;
    clientId?: string;
    entryType?: EntryType;
    planId?: string;
    planName?: string;
    planState?: string;
    currentState?: string;
    scheduledDate?: string;
    amount?: number;
    takeoverFundingType?: string;
    scheduleManually?: boolean;
    transactionLockId?: string;
    paymentSourceType?: string;
    fundingSource?: FundingSourceType;
    postingScheduleType?: PostingScheduleType;
    parentType?: ParentType;
    override?: boolean;
    allowedRecalculationType?: AllowedRecalculationType;
    hasTakeoverPlan?: boolean;
    takeoverYearToDate?: string;
    paymentSourceId?: string;
}

export interface EntryPlanSummary {
    entryType?: EntryType;
    planId?: string;
    currentState?: string;
    scheduledDate?: string;
    amountSum?: number;
    planState?: string;
    takeoverFundingType?: string;
}

export interface FeatureAccount {
    id?: string;
    name?: string;
    balance?: number;
    balanceDue?: number;
    maxAdvanceAmount?: number;
    currentState?: string;
}

export interface PaymentSource extends EntityBase {
    divisionId?: string;
    paymentAccountId: string;
    paymentSourceType: PaymentSourceType;
    achSecCodeIndicator?: TransactionCodeSecIndicator;
    achFrequencyIndicator?: TransactionFrequencyIndicator;
}

export interface Posting extends EntityBase {
    profileId?: string;
    profileType?: ProfileType;
    planId?: string;
    accountId?: string;
    sourceAccountId?: string;
    sourceAccountType?: SourceAccountType;
    amount?: number;
    entryType?: EntryType;
    postingType?: TransactionType;
}

export interface ScheduledPostingsAction extends EntityBase {
    searchCriteria?: SearchCriteria;
    paymentDetails?: EntryPaymentDetails;
    paymentSourceType?: PaymentSourceType;
    isSubsequentProcess?: boolean;
}

export interface SettlementDetails {
  benefitPlanId?: string;
  amount?: number;
  name?: string;
  scheduledDate?: string;
}

export interface SettlementDetail {
    benefitPlanId?: string;
    name?: string;
    amount?: number;
    currentState?: string;
    transactionDateTime?: string;
    paymentSourceId?: string;
    paymentDetails?: EntryPaymentDetails;
}

export interface Trade extends EntityBase {
    cashAccountMinimumBalance?: number;
    minimumTradeAmount?: number;
    tradeType?: TradeType;
    settledAmount?: number;
    requestedAmount?: number;
    investedBalance?: number;
    pptabBalance?: number;
    requestFileDocumentId?: string;
    tradeResponseReceivedDateTime?: string;
    tradeResponsePostedDateTime?: string;
    investmentAccountId?: string;
    investmentRecordKeepingId?: string;
    tradeCustodyPartner?: string;
    settledDate?: string;
    tradeInitiationType?: TradeInitiationType;
}

export interface InvestmentBalance extends EntityBase {
    investmentAccountId?: string;
    investmentRecordKeepingId?: string;
    vestedBalance?: number;
    nonVestedBalance?: number;
}

export interface VerificationSummary {
    benefitAccountId?: string;
    totalDisbursements?: number;
    verifiedDisbursements?: number;
    unverifiedDisbursements?: number;
    unusedVerifications?: number;
    imputedIncome?: number;
}

export interface Criteria {
    key?: string;
    value?: string;
    matchType?: MatchType;
    chainType?: ChainType;
    groupCriteria?: GroupCriteria[];
}

export interface Aggregate {
    key?: string;
    aggregateType?: AggregateType;
    groupBy?: boolean;
}

export interface Error {
    message?: string;
    fields?: object;
}

export interface GroupCriteria {
    key?: string;
    value?: string;
    matchType?: MatchType;
    chainType?: ChainType;
}

export interface PingResponse {
    serverTime: ServerTime;
    services?: Service[];
}

export type SearchCriteria = Criteria[];

export type AggregateCriteria = Aggregate[];

export interface Service {
    name?: string;
    serverTime?: string;
}

export type ServerTime = string;

export interface OperationalBalanceInfo {
    profileName: string;
    benefitPlanName: string;
    benefitAccountId: string;
    benefitPlanId: string;
    sumOfEntries: number;
    deductibleBalance?: DeductibleBalance;
    payoutBalance?: PayoutBalance;
    operationalAccountsCreated: boolean;
}

export interface DeductibleBalance {
    totalDeductibleForProfile: number;
    remainingTotalDeductibleForProfile?: number;
    planDeductibleForEachPerson?: number;
    totalDeductibleForGroup?: number;
    planDeductibleForGroup?: number;
    entries: Entry[];
}

export interface PayoutBalance {
    totalPayoutForProfile: number;
    remainingTotalPayoutForProfile?: number;
    totalPayoutForGroup: number;
    entries: Entry[];
}

export interface SoaBalance {
    accountId: string;
    available: number;
}

export interface AccountBalance {
    accountId?: string;
    accountType?: string;
    externalAccountId?: string;
    balance?: number;
    debit?: number;
    credit?: number;
}

export interface PayeeDistributionDetail {
    remittancePaymentMethodAccountId?: string;
    planId?: string;
    payeeId?: string;
    paymentSourceId?: string;
    payeeName?: string;
}

export interface PayeePaymentSourceInfo {
    id?: string;
    parentType?: ParentType;
    paymentSourceType?: PaymentSourceType;
}

export interface InvestmentTrade {
    investmentInstitutionType?: string;
    benefitAccountId?: string;
    individualId?: string;
    benefitPlanId?: string;
    soaAccountId?: string;
    pptabBalance?: number;
    cashAccountMinBalance?: number;
    minBuyTradeAmount?: number;
    minSellTradeAmount?: number;
    investmentBalance?: InvestmentBalance;
    tradeInitiationType?: TradeInitiationType;
    hasPendingTrade?: boolean;
    trade?: TradeAmountAndType;
}

export type OperationalBalanceInfoList = OperationalBalanceInfo[];

export type AccountPostings = AccountPosting[];

export type BankAccounts = BankAccount[];

export type BenefitAccountBalances = BenefitAccountBalance[];

export type InterestPostings = InterestPosting[];

export type OperationalAccountBalances = OperationalAccountBalance[];

export type PaymentSourceAccounts = PaymentSourceAccount[];

export type BenefitAccountElections = BenefitAccountElection[];

export interface BenefitAccountEntryExes {
    total?: number;
    items?: BenefitAccountEntryEx[];
}

export type BenefitAccounts = BenefitAccount[];

export type PersonBenefitAccountFeatureRestrictions = PersonBenefitAccountFeatureRestriction[];

export interface CRUDEntriesCommandData {
    insertCommandData?: Entries;
    removeCommandData?: Entries;
    updateCommandData?: Entries;
    useOptimisticLocking?: boolean;
}

export type DependentBenefitAccesses = DependentBenefitAccess[];

export type Entries = Entry[];

export type EntryPostings = EntryPosting[];

export type EntrySummaries = EntrySummary[];

export type EntryPlans = EntryPlan[];

export type EntryPlanSummaries = EntryPlanSummary[];

export type FeatureAccounts = FeatureAccount[];

export type PaymentSources = PaymentSource[];

export type Postings = Posting[];

export type Elections = Election[];

export type Trades = Trade[];

export type InvestmentBalances = InvestmentBalance[];

export type VerificationSummaries = VerificationSummary[];

export interface AdditionalPBAFRProperties {
    skipXFEvent?: boolean;
}

export interface RequestType {
    expenseType?: string;
    serviceType?: string;
    limit?: number;
}

export type RequestTypes = RequestType[];

export interface TradeAmountAndType {
    amount?: number;
    type?: TradeType;
}

export enum AccountCommandType {
    ActiveToActive = 'ActiveToActive',
    ActiveToInactive = 'ActiveToInactive',
    EnrichToActive = 'EnrichToActive',
    EnrichToProcessingError = 'EnrichToProcessingError',
    InactiveToActive = 'InactiveToActive',
    InactiveToInactive = 'InactiveToInactive',
    NeedsProcessingToActive = 'NeedsProcessingToActive',
    NeedsProcessingToProcessingError = 'NeedsProcessingToProcessingError',
    PendingToActive = 'PendingToActive',
    PendingToNeedsProcessing = 'PendingToNeedsProcessing',
    StartToEnrich = 'StartToEnrich',
    StartToPending = 'StartToPending',
}

export enum BankAccountCommandType {
    ActiveToActive = 'ActiveToActive',
    ActiveToExpired = 'ActiveToExpired',
    ActiveToInactive = 'ActiveToInactive',
    ActiveToLocked = 'ActiveToLocked',
    ActiveToOnHold = 'ActiveToOnHold',
    ActiveToRemoved = 'ActiveToRemoved',
    InUseToActive = 'InUseToActive',
    InUseToInactive = 'InUseToInactive',
    InUseToOnHold = 'InUseToOnHold',
    InUseToRemoved = 'InUseToRemoved',
    InactiveToActive = 'InactiveToActive',
    InactiveToLocked = 'InactiveToLocked',
    OnHoldToActive = 'OnHoldToActive',
    OnHoldToInUse = 'OnHoldToInUse',
    OnHoldToRemoved = 'OnHoldToRemoved',
    PendingToActive = 'PendingToActive',
    PendingToError = 'PendingToError',
    StartToActive = 'StartToActive',
    StartToError = 'StartToError',
    StartToInactive = 'StartToInactive',
    StartToLocked = 'StartToLocked',
    StartToPending = 'StartToPending',
    UpgradeToActive = 'UpgradeToActive',
}

export enum BenefitAccountCommandType {
    ALOAWithBenefitsToALOAWithBenefits = 'ALOAWithBenefitsToALOAWithBenefits',
    ALOAWithBenefitsToActive = 'ALOAWithBenefitsToActive',
    ALOAWithBenefitsToActiveNonDisbursable = 'ALOAWithBenefitsToActiveNonDisbursable',
    ALOAWithBenefitsToClosedDisbursementOnly = 'ALOAWithBenefitsToClosedDisbursementOnly',
    ALOAWithBenefitsToGracePeriod = 'ALOAWithBenefitsToGracePeriod',
    ALOAWithBenefitsToInactive = 'ALOAWithBenefitsToInactive',
    ALOAWithBenefitsToReconciliation = 'ALOAWithBenefitsToReconciliation',
    ALOAWithBenefitsToRunOut = 'ALOAWithBenefitsToRunOut',
    ALOAWithoutBenefitsToALOAWithoutBenefits = 'ALOAWithoutBenefitsToALOAWithoutBenefits',
    ALOAWithoutBenefitsToActive = 'ALOAWithoutBenefitsToActive',
    ALOAWithoutBenefitsToActiveNonDisbursable = 'ALOAWithoutBenefitsToActiveNonDisbursable',
    ALOAWithoutBenefitsToClosedDisbursementOnly = 'ALOAWithoutBenefitsToClosedDisbursementOnly',
    ALOAWithoutBenefitsToGracePeriod = 'ALOAWithoutBenefitsToGracePeriod',
    ALOAWithoutBenefitsToInactive = 'ALOAWithoutBenefitsToInactive',
    ALOAWithoutBenefitsToReconciliation = 'ALOAWithoutBenefitsToReconciliation',
    ALOAWithoutBenefitsToRunOut = 'ALOAWithoutBenefitsToRunOut',
    ActiveNonDisbursableToALOAWithoutBenefits = 'ActiveNonDisbursableToALOAWithoutBenefits',
    ActiveNonDisbursableToActive = 'ActiveNonDisbursableToActive',
    ActiveNonDisbursableToActiveNonDisbursable = 'ActiveNonDisbursableToActiveNonDisbursable',
    ActiveNonDisbursableToFinalizing = 'ActiveNonDisbursableToFinalizing',
    ActiveNonDisbursableToGracePeriod = 'ActiveNonDisbursableToGracePeriod',
    ActiveNonDisbursableToInactive = 'ActiveNonDisbursableToInactive',
    ActiveNonDisbursableToReconciliation = 'ActiveNonDisbursableToReconciliation',
    ActiveNonDisbursableToRunOut = 'ActiveNonDisbursableToRunOut',
    ActiveToALOAWithBenefits = 'ActiveToALOAWithBenefits',
    ActiveToALOAWithoutBenefits = 'ActiveToALOAWithoutBenefits',
    ActiveToActive = 'ActiveToActive',
    ActiveToActiveNonDisbursable = 'ActiveToActiveNonDisbursable',
    ActiveToClosed = 'ActiveToClosed',
    ActiveToClosedDisbursementOnly = 'ActiveToClosedDisbursementOnly',
    ActiveToGracePeriod = 'ActiveToGracePeriod',
    ActiveToInactive = 'ActiveToInactive',
    ActiveToReconciliation = 'ActiveToReconciliation',
    ActiveToRunOut = 'ActiveToRunOut',
    AnyToPropagatingDateEdits = 'AnyToPropagatingDateEdits',
    AuditAdjustmentToAuditAdjustment = 'AuditAdjustmentToAuditAdjustment',
    AuditAdjustmentToFinalizing = 'AuditAdjustmentToFinalizing',
    ClosedToFinalizing = 'ClosedToFinalizing',
    ConversionToActive = 'ConversionToActive',
    ConversionToActiveNonDisbursable = 'ConversionToActiveNonDisbursable',
    CreatedToEnrolled = 'CreatedToEnrolled',
    CreatedToErrorXFAuthFailure = 'CreatedToErrorXFAuthFailure',
    CreatedToErrorXFDuplicate = 'CreatedToErrorXFDuplicate',
    CreatedToErrorXFRetry = 'CreatedToErrorXFRetry',
    EnrolledToEnrolled = 'EnrolledToEnrolled',
    EnrolledToInitiated = 'EnrolledToInitiated',
    EnrolledToRemoved = 'EnrolledToRemoved',
    EnrolledToUnenrolled = 'EnrolledToUnenrolled',
    ErrorToFinalizing = 'ErrorToFinalizing',
    ErrorXFAuthFailureToFinalized = 'ErrorXFAuthFailureToFinalized',
    ErrorXFDuplicateToFinalized = 'ErrorXFDuplicateToFinalized',
    ErrorXFRetryToFinalized = 'ErrorXFRetryToFinalized',
    FinalizedToAuditAdjustment = 'FinalizedToAuditAdjustment',
    FinalizingToError = 'FinalizingToError',
    FinalizingToFinalized = 'FinalizingToFinalized',
    FinalizingToFinalizingError = 'FinalizingToFinalizingError',
    GeneratePodEntries = 'GeneratePodEntries',
    GracePeriodToActiveNonDisbursable = 'GracePeriodToActiveNonDisbursable',
    GracePeriodToGracePeriod = 'GracePeriodToGracePeriod',
    GracePeriodToInactive = 'GracePeriodToInactive',
    GracePeriodToReconciliation = 'GracePeriodToReconciliation',
    GracePeriodToRunOut = 'GracePeriodToRunOut',
    IdVerificationPendingToActive = 'IdVerificationPendingToActive',
    IdVerificationPendingToActiveNonDisbursable = 'IdVerificationPendingToActiveNonDisbursable',
    IdVerificationPendingToClosed = 'IdVerificationPendingToClosed',
    IdVerificationPendingToFinalizing = 'IdVerificationPendingToFinalizing',
    IdVerificationPendingToIdVerificationPending = 'IdVerificationPendingToIdVerificationPending',
    IdVerificationPendingToTOUAgreementPending = 'IdVerificationPendingToTOUAgreementPending',
    InactiveToActive = 'InactiveToActive',
    InactiveToActiveNonDisbursable = 'InactiveToActiveNonDisbursable',
    InactiveToFinalizing = 'InactiveToFinalizing',
    InactiveToInactive = 'InactiveToInactive',
    InitiatedToActive = 'InitiatedToActive',
    InitiatedToActiveNonDisbursable = 'InitiatedToActiveNonDisbursable',
    InitiatedToClosed = 'InitiatedToClosed',
    InitiatedToIdVerificationPending = 'InitiatedToIdVerificationPending',
    InitiatedToInitiated = 'InitiatedToInitiated',
    InitiatedToRemoved = 'InitiatedToRemoved',
    InitiatedToTOUAgreementPending = 'InitiatedToTOUAgreementPending',
    InitiatedToUnenrolled = 'InitiatedToUnenrolled',
    PendingApprovalToCreated = 'PendingApprovalToCreated',
    PendingApprovalToEnrolled = 'PendingApprovalToEnrolled',
    PendingApprovalToFinalized = 'PendingApprovalToFinalized',
    PendingApprovalToPendingApproval = 'PendingApprovalToPendingApproval',
    PendingApprovalToRemoved = 'PendingApprovalToRemoved',
    PendingApprovalToUnenrolled = 'PendingApprovalToUnenrolled',
    PropagatingDateEditsToAny = 'PropagatingDateEditsToAny',
    ReconciliationToFinalizing = 'ReconciliationToFinalizing',
    ReconciliationToInactive = 'ReconciliationToInactive',
    ReconciliationToReconciliation = 'ReconciliationToReconciliation',
    ReconciliationToRolloverProcessing = 'ReconciliationToRolloverProcessing',
    RolloverCompleteToFinalizing = 'RolloverCompleteToFinalizing',
    RolloverProcessingToError = 'RolloverProcessingToError',
    RolloverProcessingToRolloverComplete = 'RolloverProcessingToRolloverComplete',
    RunOutToActiveNonDisbursable = 'RunOutToActiveNonDisbursable',
    RunOutToInactive = 'RunOutToInactive',
    RunOutToReconciliation = 'RunOutToReconciliation',
    RunOutToRunOut = 'RunOutToRunOut',
    StartToCreated = 'StartToCreated',
    StartToEnrolled = 'StartToEnrolled',
    StartToError = 'StartToError',
    StartToPendingApproval = 'StartToPendingApproval',
    TOUAgreementPendingToActive = 'TOUAgreementPendingToActive',
    TOUAgreementPendingToActiveNonDisbursable = 'TOUAgreementPendingToActiveNonDisbursable',
    TOUAgreementPendingToClosed = 'TOUAgreementPendingToClosed',
    TOUAgreementPendingToFinalizing = 'TOUAgreementPendingToFinalizing',
    TOUAgreementPendingToTOUAgreementPending = 'TOUAgreementPendingToTOUAgreementPending',
    UnenrolledToEnrolled = 'UnenrolledToEnrolled',
    UnenrolledToFinalizing = 'UnenrolledToFinalizing',
    UnenrolledToPendingApproval = 'UnenrolledToPendingApproval',
    UpgradeToConversion = 'UpgradeToConversion',
}

export enum PersonBenefitAccountFeatureRestrictionCommandType {
    ActiveToActive = 'ActiveToActive',
    ActiveToRemoved = 'ActiveToRemoved',
    StartToActive = 'StartToActive',
}

export enum DependentBenefitAccessCommandType {
    ActiveToActive = 'ActiveToActive',
    ActiveToInactive = 'ActiveToInactive',
    ConversionToActive = 'ConversionToActive',
    ConversionToErrorXFAuthFailure = 'ConversionToErrorXFAuthFailure',
    ConversionToErrorXFDuplicate = 'ConversionToErrorXFDuplicate',
    ConversionToErrorXFRetry = 'ConversionToErrorXFRetry',
    InactiveToActive = 'InactiveToActive',
    InactiveToInactive = 'InactiveToInactive',
    InactiveToRemoved = 'InactiveToRemoved',
    PendingApprovalToActive = 'PendingApprovalToActive',
    PendingApprovalToInactive = 'PendingApprovalToInactive',
    PendingApprovalToPendingApproval = 'PendingApprovalToPendingApproval',
    PendingApprovalToRemoved = 'PendingApprovalToRemoved',
    StartToActive = 'StartToActive',
    StartToInactive = 'StartToInactive',
    StartToPendingApproval = 'StartToPendingApproval',
    UpgradeToConversion = 'UpgradeToConversion',
}

export enum EntryCommandType {
    CardPaymentAuthorizedToCardAuthorizationFailed = 'CardPaymentAuthorizedToCardAuthorizationFailed',
    CardPaymentAuthorizedToCardPaymentSettled = 'CardPaymentAuthorizedToCardPaymentSettled',
    CardPaymentSettledToPendingPublished = 'CardPaymentSettledToPendingPublished',
    DisputedToDisputeRejected = 'DisputedToDisputeRejected',
    DisputedToDisputeSettled = 'DisputedToDisputeSettled',
    EnrichToEntered = 'EnrichToEntered',
    EnrichToNeedsProcessing = 'EnrichToNeedsProcessing',
    EnrichToPublished = 'EnrichToPublished',
    EnrichToRefunded = 'EnrichToRefunded',
    EnteredToDisputeSettled = 'EnteredToDisputeSettled',
    EnteredToDisputed = 'EnteredToDisputed',
    EnteredToEntered = 'EnteredToEntered',
    EnteredToRejected = 'EnteredToRejected',
    EnteredToReversalPublished = 'EnteredToReversalPublished',
    EnteredToSettled = 'EnteredToSettled',
    NeedsProcessingToEnrich = 'NeedsProcessingToEnrich',
    NeedsProcessingToNeedsProcessing = 'NeedsProcessingToNeedsProcessing',
    NeedsProcessingToProcessingError = 'NeedsProcessingToProcessingError',
    NotPublishedToNotPublished = 'NotPublishedToNotPublished',
    NotPublishedToPendingPublished = 'NotPublishedToPendingPublished',
    NotPublishedToScheduled = 'NotPublishedToScheduled',
    PendingPublishedToError = 'PendingPublishedToError',
    PendingPublishedToErrorXFAuthFailure = 'PendingPublishedToErrorXFAuthFailure',
    PendingPublishedToErrorXFDuplicate = 'PendingPublishedToErrorXFDuplicate',
    PendingPublishedToErrorXFRetry = 'PendingPublishedToErrorXFRetry',
    PendingPublishedToNoPostings = 'PendingPublishedToNoPostings',
    PendingPublishedToPublished = 'PendingPublishedToPublished',
    PendingPublishedToReversalPublished = 'PendingPublishedToReversalPublished',
    PublishedToEntered = 'PublishedToEntered',
    PublishedToNeedsProcessing = 'PublishedToNeedsProcessing',
    PublishedToReversalPublished = 'PublishedToReversalPublished',
    ReversalPublishedToReversed = 'ReversalPublishedToReversed',
    ReversedToReversed = 'ReversedToReversed',
    ScheduledToClaimed = 'ScheduledToClaimed',
    ScheduledToError = 'ScheduledToError',
    ScheduledToExpired = 'ScheduledToExpired',
    ScheduledToNotPublished = 'ScheduledToNotPublished',
    ScheduledToPendingPublished = 'ScheduledToPendingPublished',
    ScheduledToRemoved = 'ScheduledToRemoved',
    ScheduledToScheduled = 'ScheduledToScheduled',
    SettledToRejected = 'SettledToRejected',
    StartToCardAuthorizationFailed = 'StartToCardAuthorizationFailed',
    StartToCardPaymentAuthorized = 'StartToCardPaymentAuthorized',
    StartToEnrich = 'StartToEnrich',
    StartToEntered = 'StartToEntered',
    StartToError = 'StartToError',
    StartToPendingPublished = 'StartToPendingPublished',
    StartToScheduled = 'StartToScheduled',
}

export enum EntriesCommandType {
    ScheduledToScheduled = 'ScheduledToScheduled',
    StartToError = 'StartToError',
    StartToScheduled = 'StartToScheduled',
}

export enum PaymentSourceCommandType {
    ActiveToInactive = 'ActiveToInactive',
    ActiveToPending = 'ActiveToPending',
    ActiveToRemoved = 'ActiveToRemoved',
    ActiveToSuspended = 'ActiveToSuspended',
    ActiveToUsed = 'ActiveToUsed',
    CreatedToActive = 'CreatedToActive',
    CreatedToPendingXF = 'CreatedToPendingXF',
    InactiveToActive = 'InactiveToActive',
    PendingToActive = 'PendingToActive',
    PendingToError = 'PendingToError',
    PendingXFToActive = 'PendingXFToActive',
    PendingXFToErrorXFAuthFailure = 'PendingXFToErrorXFAuthFailure',
    PendingXFToErrorXFDuplicate = 'PendingXFToErrorXFDuplicate',
    PendingXFToErrorXFRetry = 'PendingXFToErrorXFRetry',
    StartToCreated = 'StartToCreated',
    StartToError = 'StartToError',
    StartToPending = 'StartToPending',
    SuspendedToActive = 'SuspendedToActive',
}

export enum PostingCommandType {
    AnyToRemoved = 'AnyToRemoved',
    EnrichToEntered = 'EnrichToEntered',
    EnrichToPublished = 'EnrichToPublished',
    NeedsProcessingToEntered = 'NeedsProcessingToEntered',
    NeedsProcessingToProcessingError = 'NeedsProcessingToProcessingError',
    StartToEnrich = 'StartToEnrich',
    StartToEntered = 'StartToEntered',
    StartToNeedsProcessing = 'StartToNeedsProcessing',
}

export enum InterestPostingCommandType {
    ErrorToProcessing = 'ErrorToProcessing',
    ErrorToSearching = 'ErrorToSearching',
    ProcessingToComplete = 'ProcessingToComplete',
    SearchingToProcessing = 'SearchingToProcessing',
    StartToSearching = 'StartToSearching',
}

export enum InvestmentContributionPostingCommandType {
    StartToProcessing = 'StartToProcessing',
}

export enum ProcessSettlementCommandType {
    StartToProcessing = 'StartToProcessing',
}

export enum ProcessCABFundingCommandType {
    StartToProcessing = 'StartToProcessing',
}

export enum RecalculateBenefitAccountCommandType {
    StartToProcessing = 'StartToProcessing',
}

export enum ScheduleAdjustmentsCommandType {
    StartToProcessing = 'StartToProcessing',
}

export enum ScheduledPostingsActionCommandType {
    ProcessScheduledPostings = 'ProcessScheduledPostings',
}

export enum ElectionCommandType {
    ActiveToActive = 'ActiveToActive',
    ActiveToInactive = 'ActiveToInactive',
    ConversionToActive = 'ConversionToActive',
    PendingAmountToInactive = 'PendingAmountToInactive',
    PendingAmountToPending = 'PendingAmountToPending',
    PendingAmountToPendingApproval = 'PendingAmountToPendingApproval',
    PendingApprovalToInactive = 'PendingApprovalToInactive',
    PendingApprovalToPending = 'PendingApprovalToPending',
    PendingToActive = 'PendingToActive',
    PendingToError = 'PendingToError',
    PendingToInactive = 'PendingToInactive',
    PendingToPending = 'PendingToPending',
    StartToError = 'StartToError',
    StartToPending = 'StartToPending',
    StartToPendingAmount = 'StartToPendingAmount',
    StartToPendingApproval = 'StartToPendingApproval',
    UpgradeToConversion = 'UpgradeToConversion',
}

export enum TradeCommandType {
    AnyToRemoved = 'AnyToRemoved',
    EntryPublishedToCancelled = 'EntryPublishedToCancelled',
    EntryPublishedToPendingTradeRequestFile = 'EntryPublishedToPendingTradeRequestFile',
    PendingTradeRequestFileToCancelled = 'PendingTradeRequestFileToCancelled',
    PendingTradeRequestFileToPendingTradeResponse = 'PendingTradeRequestFileToPendingTradeResponse',
    PendingTradeResponseToTradeResponseReceived = 'PendingTradeResponseToTradeResponseReceived',
    SettlementEntriesPublishedToSettled = 'SettlementEntriesPublishedToSettled',
    StartToEntryPublished = 'StartToEntryPublished',
    StartToPendingTradeRequestFile = 'StartToPendingTradeRequestFile',
    TradeResponseReceivedToSettlementEntriesPublished = 'TradeResponseReceivedToSettlementEntriesPublished',
}

export enum InvestmentBalanceCommandType {
    ActiveToActive = 'ActiveToActive',
    StartToActive = 'StartToActive',
}

export enum AccountState {
    Active = 'Active',
    Enrich = 'Enrich',
    Inactive = 'Inactive',
    NeedsProcessing = 'NeedsProcessing',
    Pending = 'Pending',
    ProcessingError = 'ProcessingError',
    Start = 'Start',
}

export enum BankAccountState {
    Active = 'Active',
    Error = 'Error',
    Expired = 'Expired',
    InUse = 'InUse',
    Inactive = 'Inactive',
    Locked = 'Locked',
    OnHold = 'OnHold',
    Pending = 'Pending',
    Removed = 'Removed',
    Start = 'Start',
    Upgrade = 'Upgrade',
}

export enum BenefitAccountState {
    ALOAWithBenefits = 'ALOAWithBenefits',
    ALOAWithoutBenefits = 'ALOAWithoutBenefits',
    Active = 'Active',
    ActiveNonDisbursable = 'ActiveNonDisbursable',
    Closed = 'Closed',
    ClosedDisbursementOnly = 'ClosedDisbursementOnly',
    Cobra = 'Cobra',
    Conversion = 'Conversion',
    Created = 'Created',
    Enrolled = 'Enrolled',
    Error = 'Error',
    ErrorXFAuthFailure = 'ErrorXFAuthFailure',
    ErrorXFDuplicate = 'ErrorXFDuplicate',
    ErrorXFRetry = 'ErrorXFRetry',
    Finalized = 'Finalized',
    Finalizing = 'Finalizing',
    FinalizingError = 'FinalizingError',
    GracePeriod = 'GracePeriod',
    IdVerificationPending = 'IdVerificationPending',
    Inactive = 'Inactive',
    Initiated = 'Initiated',
    PendingApproval = 'PendingApproval',
    PropagatingDateEdits = 'PropagatingDateEdits',
    Reconciliation = 'Reconciliation',
    Removed = 'Removed',
    RolloverComplete = 'RolloverComplete',
    RolloverProcessing = 'RolloverProcessing',
    RunOut = 'RunOut',
    Start = 'Start',
    TOUAgreementPending = 'TOUAgreementPending',
    Unenrolled = 'Unenrolled',
    Upgrade = 'Upgrade',
}

export enum DependentBenefitAccessState {
    Active = 'Active',
    Conversion = 'Conversion',
    ErrorXFAuthFailure = 'ErrorXFAuthFailure',
    ErrorXFDuplicate = 'ErrorXFDuplicate',
    ErrorXFRetry = 'ErrorXFRetry',
    Inactive = 'Inactive',
    PendingApproval = 'PendingApproval',
    Removed = 'Removed',
    Upgrade = 'Upgrade',
}

export enum ElectionState {
    Active = 'Active',
    Conversion = 'Conversion',
    Error = 'Error',
    Inactive = 'Inactive',
    Pending = 'Pending',
    PendingAmount = 'PendingAmount',
    PendingApproval = 'PendingApproval',
    Upgrade = 'Upgrade',
}

export enum InterestPostingState {
    Complete = 'Complete',
    Error = 'Error',
    Processing = 'Processing',
    Searching = 'Searching',
    Start = 'Start',
}

export enum PersonBenefitAccountFeatureRestrictionState {
    Active = 'Active',
    Removed = 'Removed',
    Start = 'Start',
}

export enum EntryState {
    CardAuthorizationFailed = 'CardAuthorizationFailed',
    CardPaymentAuthorized = 'CardPaymentAuthorized',
    CardPaymentSettled = 'CardPaymentSettled',
    Claimed = 'Claimed',
    DisputeRejected = 'DisputeRejected',
    DisputeSettled = 'DisputeSettled',
    Disputed = 'Disputed',
    Enrich = 'Enrich',
    EnrichError = 'EnrichError',
    Entered = 'Entered',
    Error = 'Error',
    ErrorXFAuthFailure = 'ErrorXFAuthFailure',
    ErrorXFDuplicate = 'ErrorXFDuplicate',
    ErrorXFRetry = 'ErrorXFRetry',
    Expired = 'Expired',
    NeedsProcessing = 'NeedsProcessing',
    NoPostings = 'NoPostings',
    NotPublished = 'NotPublished',
    PendingPublished = 'PendingPublished',
    ProcessingError = 'ProcessingError',
    Published = 'Published',
    Refunded = 'Refunded',
    Rejected = 'Rejected',
    Removed = 'Removed',
    ReversalPublished = 'ReversalPublished',
    Reversed = 'Reversed',
    Scheduled = 'Scheduled',
    Settled = 'Settled',
    Start = 'Start',
}

export enum PaymentSourceState {
    Active = 'Active',
    Created = 'Created',
    Error = 'Error',
    ErrorXFAuthFailure = 'ErrorXFAuthFailure',
    ErrorXFDuplicate = 'ErrorXFDuplicate',
    ErrorXFRetry = 'ErrorXFRetry',
    Inactive = 'Inactive',
    Pending = 'Pending',
    PendingXF = 'PendingXF',
    Removed = 'Removed',
    Start = 'Start',
    Suspended = 'Suspended',
    Used = 'Used',
}

export enum PostingState {
    Entered = 'Entered',
    NeedsProcessing = 'NeedsProcessing',
    ProcessingError = 'ProcessingError',
    Removed = 'Removed',
    Start = 'Start',
}

export enum TradeState {
    Cancelled = 'Cancelled',
    EntryPublished = 'EntryPublished',
    Error = 'Error',
    PendingTradeRequestFile = 'PendingTradeRequestFile',
    PendingTradeResponse = 'PendingTradeResponse',
    Settled = 'Settled',
    SettlementEntriesPublished = 'SettlementEntriesPublished',
    TradeResponseReceived = 'TradeResponseReceived',
}

export enum InvestmentBalanceState {
    Active = 'Active',
    Error = 'Error',
    Start = 'Start',
}

export enum AddressOwnerType {
    External = 'External',
    Primary = 'Primary',
}

export enum ParentType {
    ADVANCE = 'ADVANCE',
    AGENCY = 'AGENCY',
    AGENCY_CLIENT = 'AGENCY_CLIENT',
    AGENT = 'AGENT',
    BENEFIT_ACCOUNT = 'BENEFIT_ACCOUNT',
    BENEFIT_PLAN = 'BENEFIT_PLAN',
    BUREAU = 'BUREAU',
    CARD = 'CARD',
    CHARITY = 'CHARITY',
    CLIENT = 'CLIENT',
    CLIENT_CAUSE = 'CLIENT_CAUSE',
    DEPENDENT = 'DEPENDENT',
    DHA = 'DHA',
    DONATION = 'DONATION',
    ELIGIBILITY_EVENT = 'ELIGIBILITY_EVENT',
    ENTRY = 'ENTRY',
    INDIVIDUAL = 'INDIVIDUAL',
    INSTANCE = 'INSTANCE',
    PAYEE = 'PAYEE',
    PAYMENT_ACCOUNT = 'PAYMENT_ACCOUNT',
    PAYMENT_ACCOUNT_GROUP = 'PAYMENT_ACCOUNT_GROUP',
    PAYMENT_PLAN = 'PAYMENT_PLAN',
    PLAN_PAYEE = 'PLAN_PAYEE',
    PROVIDER = 'PROVIDER',
    PYAB = 'PYAB',
    REQUEST = 'REQUEST',
    REQUEST_PAYMENT = 'REQUEST_PAYMENT',
    UHA = 'UHA',
}

export enum BalanceType {
    Carryover = 'Carryover',
    Full = 'Full',
    Inactive = 'Inactive',
    Limited = 'Limited',
}

export enum BankAccountType {
    BusinessChecking = 'BusinessChecking',
    BusinessSavings = 'BusinessSavings',
    GeneralLedger = 'GeneralLedger',
    PersonalChecking = 'PersonalChecking',
    PersonalSavings = 'PersonalSavings',
}

export enum AccountType {
    BAB = 'BAB',
    BCA = 'BCA',
    BCTA = 'BCTA',
    BEA = 'BEA',
    BFA = 'BFA',
    BINPA = 'BINPA',
    BINT = 'BINT',
    BTCA = 'BTCA',
    BXFBO = 'BXFBO',
    BXPTD = 'BXPTD',
    CAB = 'CAB',
    CARD_CORRECTION = 'CARD_CORRECTION',
    CARD_EXCEPTION = 'CARD_EXCEPTION',
    CARD_FORCED = 'CARD_FORCED',
    CCTA = 'CCTA',
    CDAF = 'CDAF',
    CFPHA = 'CFPHA',
    COCTA = 'COCTA',
    CPFA = 'CPFA',
    CRA = 'CRA',
    IAB = 'IAB',
    IOA = 'IOA',
    IOAB = 'IOA-B',
    IOADEDUCTIBLE = 'IOA-DEDUCTIBLE',
    IOAPAYOUT = 'IOA-PAYOUT',
    PBIN = 'PBIN',
    PCTA = 'PCTA',
    PFPHA = 'PFPHA',
    PPSEA = 'PPSEA',
    PPSIA = 'PPSIA',
    PPTAB = 'PPTAB',
    PPTAB_ADVANCE = 'PPTAB_ADVANCE',
    PSEA = 'PSEA',
    PSIA = 'PSIA',
    PYAB = 'PYAB',
    TOA = 'TOA',
    TPOOA = 'TPOOA',
}

export enum SourceAccountType {
    Card = 'Card',
    Checking = 'Checking',
    Payroll = 'Payroll',
}

export enum AddressType {
    Billing = 'Billing',
    Other = 'Other',
    Primary = 'Primary',
    Shipping = 'Shipping',
}

export enum EventSourceType {
    Card = 'Card',
    SOA = 'SOA',
    UBA = 'UBA',
}

export enum FrequencyType {
    Annual = 'Annual',
    OneTime = 'OneTime',
    Recurring = 'Recurring',
}

export enum SoaEntryType {
    Credit = 'Credit',
    Debit = 'Debit',
}

export enum AggregateType {
    COUNT = 'COUNT',
    SUM = 'SUM',
}

export enum BenefitAccountParentType {
    CLIENT = 'CLIENT',
    ENTRY = 'ENTRY',
    INDIVIDUAL = 'INDIVIDUAL',
}

export enum PaymentAccountType {
    BankAccount = 'BankAccount',
    Card = 'Card',
    Check = 'Check',
    Paypal = 'Paypal',
    Trade = 'Trade',
    Wire = 'Wire',
}

export enum PaymentVendor {
    Braintree = 'Braintree',
    XFormative = 'XFormative',
}

export enum MerchantAccount {
    Giving = 'Giving',
    TASC = 'TASC',
}

export enum BenefitPlanOrFeatureType {
    Advance = 'Advance',
    BenefitPlan = 'BenefitPlan',
    MyCash = 'MyCash',
}

export enum BenefitPlanCoverageType {
    ByMemberUnlimited = 'ByMemberUnlimited',
    Family = 'Family',
    Single = 'Single',
    SinglePlusOne = 'SinglePlusOne',
    SinglePlusTwo = 'SinglePlusTwo',
}

export enum CardType {
    AmericanExpress = 'American Express',
    Discover = 'Discover',
    MasterCard = 'MasterCard',
    Visa = 'Visa',
}

export enum DisbursementMethodType {
    ACH = 'ACH',
    MastercardSend = 'MastercardSend',
    TASCCard = 'TASCCard',
}

export enum ElectionScheduleType {
    Annually = 'Annually',
    Monthly = 'Monthly',
    PerPayPeriod = 'PerPayPeriod',
    UserInitiated = 'UserInitiated',
}

export enum ElectionProfileType {
    Client = 'Client',
    Individual = 'Individual',
}

export enum ElectionCalculationMethod {
    Custom = 'Custom',
    System = 'System',
    User = 'User',
}

export enum OperationalAccountProfileType {
    Dependent = 'Dependent',
    Individual = 'Individual',
}

export enum EntryType {
    ACHConvenienceFee = 'ACHConvenienceFee',
    ACHConvenienceFeeSweepAutomated = 'ACHConvenienceFeeSweepAutomated',
    ACHConvenienceFeeSweepManual = 'ACHConvenienceFeeSweepManual',
    ATMWithdraw = 'ATMWithdraw',
    BenefitAccountBalanceAdjustment = 'BenefitAccountBalanceAdjustment',
    BenefitAccountBalanceAdjustmentBureauContribution = 'BenefitAccountBalanceAdjustmentBureauContribution',
    BenefitAccountBalanceAdjustmentUnfunded = 'BenefitAccountBalanceAdjustmentUnfunded',
    BenefitAccountBalanceTransfer = 'BenefitAccountBalanceTransfer',
    BenefitAccountCardConvenienceFee = 'BenefitAccountCardConvenienceFee',
    BenefitAccountCardFunding = 'BenefitAccountCardFunding',
    BenefitAccountChargeback = 'BenefitAccountChargeback',
    BenefitPlanFinalizationToCab = 'BenefitPlanFinalizationToCab',
    BureauBenefitAccountCardFunding = 'BureauBenefitAccountCardFunding',
    BureauBenefitAccountMyCashFunding = 'BureauBenefitAccountMyCashFunding',
    BureauContributionDraw = 'BureauContributionDraw',
    BureauContributionDrawAutomated = 'BureauContributionDrawAutomated',
    BureauContributionDrawManual = 'BureauContributionDrawManual',
    BureauDisbursementAllocationFromIGAToCDAF = 'BureauDisbursementAllocationFromIGAToCDAF',
    BureauDisbursementDraw = 'BureauDisbursementDraw',
    BureauDisbursementDrawManual = 'BureauDisbursementDrawManual',
    BureauDisbursementFromCDAFToGivingAccount = 'BureauDisbursementFromCDAFToGivingAccount',
    BureauInterestPayment = 'BureauInterestPayment',
    BureauTransferFromSecondaryBureauAutomated = 'BureauTransferFromSecondaryBureauAutomated',
    BureauTransferFromSecondaryBureauManual = 'BureauTransferFromSecondaryBureauManual',
    BureauTransferToSecondaryBureauAutomated = 'BureauTransferToSecondaryBureauAutomated',
    BureauTransferToSecondaryBureauManual = 'BureauTransferToSecondaryBureauManual',
    BuyTradeSettlement = 'BuyTradeSettlement',
    CABBalanceAdjustment = 'CABBalanceAdjustment',
    CDAFAwardToParticipant = 'CDAFAwardToParticipant',
    CDAFDisbursementToClient = 'CDAFDisbursementToClient',
    CardConvenienceFee = 'CardConvenienceFee',
    CardConvenienceFeeSweepAutomated = 'CardConvenienceFeeSweepAutomated',
    CardConvenienceFeeSweepManual = 'CardConvenienceFeeSweepManual',
    CardCorrectionNegativeAdjustment = 'CardCorrectionNegativeAdjustment',
    CardCorrectionPositiveAdjustment = 'CardCorrectionPositiveAdjustment',
    CardDisbursement = 'CardDisbursement',
    CardExceptionNegativeAdjustment = 'CardExceptionNegativeAdjustment',
    CardExceptionPositiveAdjustment = 'CardExceptionPositiveAdjustment',
    CardForcedBinNegativeAdjustment = 'CardForcedBinNegativeAdjustment',
    CardForcedBinPositiveAdjustment = 'CardForcedBinPositiveAdjustment',
    CardForcedIABNegativeAdjustment = 'CardForcedIABNegativeAdjustment',
    CardPaymentTransferFromSecondaryBureau = 'CardPaymentTransferFromSecondaryBureau',
    CardPaymentTransferToSecondaryBureau = 'CardPaymentTransferToSecondaryBureau',
    CardRefund = 'CardRefund',
    CardRequestPayment = 'CardRequestPayment',
    CashInvestmentContribution = 'CashInvestmentContribution',
    CharityNegativeAdjustment = 'CharityNegativeAdjustment',
    CharityPositiveAdjustment = 'CharityPositiveAdjustment',
    ClientBenefitPlanFinalization = 'ClientBenefitPlanFinalization',
    ClientBureauContribution = 'ClientBureauContribution',
    ClientCABContribution = 'ClientCABContribution',
    ClientCABFunding = 'ClientCABFunding',
    ClientCABToCDAF = 'ClientCABToCDAF',
    ClientCommitmentFinalization = 'ClientCommitmentFinalization',
    ClientContribution = 'ClientContribution',
    ClientFeeAssessment = 'ClientFeeAssessment',
    ClientFeeAssessmentSweepAutomated = 'ClientFeeAssessmentSweepAutomated',
    ClientFeeAssessmentSweepManual = 'ClientFeeAssessmentSweepManual',
    ClientFunding = 'ClientFunding',
    ClientFundingConversion = 'ClientFundingConversion',
    ClientNegativeFunding = 'ClientNegativeFunding',
    ClientPodFunding = 'ClientPodFunding',
    ClientRemittanceAccountNegativeAdjustment = 'ClientRemittanceAccountNegativeAdjustment',
    ClientRemittanceAccountPositiveAdjustment = 'ClientRemittanceAccountPositiveAdjustment',
    ClientRemittanceDistribution = 'ClientRemittanceDistribution',
    ConvenienceFee = 'ConvenienceFee',
    DesignatedHoldingAccountChargeback = 'DesignatedHoldingAccountChargeback',
    DesignatedHoldingAccountNegativeAdjustment = 'DesignatedHoldingAccountNegativeAdjustment',
    DesignatedHoldingAccountPositiveAdjustment = 'DesignatedHoldingAccountPositiveAdjustment',
    DisburseFromCab = 'DisburseFromCab',
    DisburseFromPayee = 'DisburseFromPayee',
    DisburseToPayee = 'DisburseToPayee',
    DisburseToPaymentSource = 'DisburseToPaymentSource',
    DisbursementAllocationFromMyCashToCDAF = 'DisbursementAllocationFromMyCashToCDAF',
    DisbursementPreSettlement = 'DisbursementPreSettlement',
    DisbursementPreSettlementRejection = 'DisbursementPreSettlementRejection',
    DisbursementRejection = 'DisbursementRejection',
    DisbursementSettlement = 'DisbursementSettlement',
    DisbursementSettlementRejection = 'DisbursementSettlementRejection',
    DisbursementToCharity = 'DisbursementToCharity',
    DonationFromIABToCharity = 'DonationFromIABToCharity',
    DonationFromIABToClientCause = 'DonationFromIABToClientCause',
    DonationFromIDAFToCharity = 'DonationFromIDAFToCharity',
    DonationFromIDAFToClientCause = 'DonationFromIDAFToClientCause',
    DonationFromIGAToCharity = 'DonationFromIGAToCharity',
    DonationFromIGAToClientCause = 'DonationFromIGAToClientCause',
    FeeChargeback = 'FeeChargeback',
    FinancialFileRejection = 'FinancialFileRejection',
    FundFromCAB = 'FundFromCAB',
    FundedConversionRolloverContribution = 'FundedConversionRolloverContribution',
    FundingPreSettlement = 'FundingPreSettlement',
    FundingPreSettlementRejection = 'FundingPreSettlementRejection',
    FundingRejection = 'FundingRejection',
    FundingSettlement = 'FundingSettlement',
    FundingSettlementRejection = 'FundingSettlementRejection',
    GivingAccountBureauFundFromMyCash = 'GivingAccountBureauFundFromMyCash',
    GivingAccountFundFromCard = 'GivingAccountFundFromCard',
    HSAOrphanFeeAssessment = 'HSAOrphanFeeAssessment',
    HSAOrphanFeeSweepAutomated = 'HSAOrphanFeeSweepAutomated',
    HSAOrphanFeeSweepManual = 'HSAOrphanFeeSweepManual',
    HsaTransfer = 'HsaTransfer',
    IDAFRefund = 'IDAFRefund',
    IGARefund = 'IGARefund',
    IndividualFeeAssessment = 'IndividualFeeAssessment',
    InvestmentBuyBureau = 'InvestmentBuyBureau',
    InvestmentBuyParticipant = 'InvestmentBuyParticipant',
    InvestmentInterest = 'InvestmentInterest',
    InvestmentSellBureau = 'InvestmentSellBureau',
    InvestmentSellParticipant = 'InvestmentSellParticipant',
    InvestmentSweep = 'InvestmentSweep',
    InvestmentSweepBuyFix = 'InvestmentSweepBuyFix',
    InvestmentSweepSellFix = 'InvestmentSweepSellFix',
    ManualRefund = 'ManualRefund',
    ManualRequestPayment = 'ManualRequestPayment',
    ManualRequestRepayment = 'ManualRequestRepayment',
    ManualRequestReturn = 'ManualRequestReturn',
    MyCashBalanceAdjustment = 'MyCashBalanceAdjustment',
    MyCashContribution = 'MyCashContribution',
    MyCashFeeAssessment = 'MyCashFeeAssessment',
    MyCashFeeSweepAutomated = 'MyCashFeeSweepAutomated',
    MyCashFeeSweepManual = 'MyCashFeeSweepManual',
    MyCashManualRefund = 'MyCashManualRefund',
    MycashThresholdDisbursement = 'MycashThresholdDisbursement',
    OperationalContribution = 'OperationalContribution',
    OperationalDeductibleContribution = 'OperationalDeductibleContribution',
    OperationalDeductibleDisbursement = 'OperationalDeductibleDisbursement',
    OperationalDisbursement = 'OperationalDisbursement',
    OperationalPayoutContribution = 'OperationalPayoutContribution',
    OperationalPayoutDisbursement = 'OperationalPayoutDisbursement',
    ParticipantAccountTransfer = 'ParticipantAccountTransfer',
    ParticipantAdvanceContribution = 'ParticipantAdvanceContribution',
    ParticipantAdvanceFunding = 'ParticipantAdvanceFunding',
    ParticipantAdvanceReplenishment = 'ParticipantAdvanceReplenishment',
    ParticipantBalanceFinalization = 'ParticipantBalanceFinalization',
    ParticipantBenefitPlanFinalization = 'ParticipantBenefitPlanFinalization',
    ParticipantBureauContribution = 'ParticipantBureauContribution',
    ParticipantCommitmentFinalization = 'ParticipantCommitmentFinalization',
    ParticipantContribution = 'ParticipantContribution',
    ParticipantDirectCobraFunding = 'ParticipantDirectCobraFunding',
    ParticipantDirectFunding = 'ParticipantDirectFunding',
    ParticipantDirectFundingConversion = 'ParticipantDirectFundingConversion',
    ParticipantFeeAssessment = 'ParticipantFeeAssessment',
    ParticipantHoldingAccountTransfer = 'ParticipantHoldingAccountTransfer',
    ParticipantInterestCreditSecondaryBureau = 'ParticipantInterestCreditSecondaryBureau',
    ParticipantPaymentAccountContribution = 'ParticipantPaymentAccountContribution',
    ParticipantPaymentAccountContributionReversal = 'ParticipantPaymentAccountContributionReversal',
    ParticipantPaymentGroupCardFunding = 'ParticipantPaymentGroupCardFunding',
    ParticipantPaymentGroupFunding = 'ParticipantPaymentGroupFunding',
    ParticipantPaymentGroupRefund = 'ParticipantPaymentGroupRefund',
    ParticipantRollover = 'ParticipantRollover',
    ParticipantToClientFunding = 'ParticipantToClientFunding',
    PayeeRemittanceAccountNegativeAdjustment = 'PayeeRemittanceAccountNegativeAdjustment',
    PayeeRemittanceAccountPositiveAdjustment = 'PayeeRemittanceAccountPositiveAdjustment',
    PayeeRemittanceDistribution = 'PayeeRemittanceDistribution',
    PaymentAccountClientBaseRemittance = 'PaymentAccountClientBaseRemittance',
    PaymentAccountClientBaseRemittanceReversal = 'PaymentAccountClientBaseRemittanceReversal',
    PaymentAccountClientFeeRemittance = 'PaymentAccountClientFeeRemittance',
    PaymentAccountClientFeeRemittanceReversal = 'PaymentAccountClientFeeRemittanceReversal',
    PaymentAccountClientSurchargeRemittance = 'PaymentAccountClientSurchargeRemittance',
    PaymentAccountClientSurchargeRemittanceReversal = 'PaymentAccountClientSurchargeRemittanceReversal',
    PaymentAccountClientUnremittance = 'PaymentAccountClientUnremittance',
    PaymentAccountPayeeBaseRemittance = 'PaymentAccountPayeeBaseRemittance',
    PaymentAccountPayeeBaseRemittanceReversal = 'PaymentAccountPayeeBaseRemittanceReversal',
    PaymentAccountPayeeFeeRemittance = 'PaymentAccountPayeeFeeRemittance',
    PaymentAccountPayeeFeeRemittanceReversal = 'PaymentAccountPayeeFeeRemittanceReversal',
    PaymentAccountPayeeSurchargeRemittance = 'PaymentAccountPayeeSurchargeRemittance',
    PaymentAccountPayeeSurchargeRemittanceReversal = 'PaymentAccountPayeeSurchargeRemittanceReversal',
    PaymentAccountPayeeUnremittance = 'PaymentAccountPayeeUnremittance',
    PaymentAdjustment = 'PaymentAdjustment',
    PaymentPlanAdminFee = 'PaymentPlanAdminFee',
    PaymentPlanAdminFeeReversal = 'PaymentPlanAdminFeeReversal',
    PaymentPlanAdminFeeSweepAutomated = 'PaymentPlanAdminFeeSweepAutomated',
    PaymentPlanAdminFeeSweepManual = 'PaymentPlanAdminFeeSweepManual',
    PaymentPlanAdminSurcharge = 'PaymentPlanAdminSurcharge',
    PaymentPlanAdminSurchargeFeeSweepAutomated = 'PaymentPlanAdminSurchargeFeeSweepAutomated',
    PaymentPlanAdminSurchargeFeeSweepManual = 'PaymentPlanAdminSurchargeFeeSweepManual',
    PaymentPlanAdminSurchargeReversal = 'PaymentPlanAdminSurchargeReversal',
    PaymentPlanAdminUnremittance = 'PaymentPlanAdminUnremittance',
    PaymentPlanNSFFeeSweepAutomated = 'PaymentPlanNSFFeeSweepAutomated',
    PaymentPlanNSFFeeSweepManual = 'PaymentPlanNSFFeeSweepManual',
    PaymentRejection = 'PaymentRejection',
    PaymentRejectionFee = 'PaymentRejectionFee',
    PaymentRejectionFeeReversal = 'PaymentRejectionFeeReversal',
    PayrollFundingPlanRollover = 'PayrollFundingPlanRollover',
    PayrollPosting = 'PayrollPosting',
    PodFundingPlanRollover = 'PodFundingPlanRollover',
    PreAuthorizationHold = 'PreAuthorizationHold',
    PreprocessedDisbursementApproved = 'PreprocessedDisbursementApproved',
    PushToDebitCard = 'PushToDebitCard',
    RemittanceStagingAccountNegativeAdjustment = 'RemittanceStagingAccountNegativeAdjustment',
    RemittanceStagingAccountPositiveAdjustment = 'RemittanceStagingAccountPositiveAdjustment',
    Reversal = 'Reversal',
    SellOrderContribution = 'SellOrderContribution',
    SellOrderContributionDraw = 'SellOrderContributionDraw',
    SellOrderFunding = 'SellOrderFunding',
    SellOrderSettlement = 'SellOrderSettlement',
    SweepBinCorrection = 'SweepBinCorrection',
    SweepBinException = 'SweepBinException',
    SweepBinPayeeAccount = 'SweepBinPayeeAccount',
    SweepCardForced = 'SweepCardForced',
    SweepPaymentProcessorBinAccount = 'SweepPaymentProcessorBinAccount',
    TakeoverDisbursement = 'TakeoverDisbursement',
    TakeoverOperationalDeductibleContribution = 'TakeoverOperationalDeductibleContribution',
    TakeoverOperationalDeductibleDisbursement = 'TakeoverOperationalDeductibleDisbursement',
    TakeoverOperationalPayoutContribution = 'TakeoverOperationalPayoutContribution',
    TakeoverOperationalPayoutDisbursement = 'TakeoverOperationalPayoutDisbursement',
    UndesignatedHoldingAccountChargeback = 'UndesignatedHoldingAccountChargeback',
    UndesignatedHoldingAccountNegativeAdjustment = 'UndesignatedHoldingAccountNegativeAdjustment',
    UndesignatedHoldingAccountPositiveAdjustment = 'UndesignatedHoldingAccountPositiveAdjustment',
    UndesignatedParticipantPaymentGroupCardFunding = 'UndesignatedParticipantPaymentGroupCardFunding',
    UndesignatedParticipantPaymentGroupFunding = 'UndesignatedParticipantPaymentGroupFunding',
    UndesignatedParticipantPaymentGroupRefund = 'UndesignatedParticipantPaymentGroupRefund',
    UnfundedConversionRolloverContribution = 'UnfundedConversionRolloverContribution',
}

export enum EntrySubType {
    ParticipantPaymentAccountContribution = 'ParticipantPaymentAccountContribution',
    ParticipantPaymentAccountContributionCredit = 'ParticipantPaymentAccountContributionCredit',
    ParticipantPaymentAccountContributionCreditReversal = 'ParticipantPaymentAccountContributionCreditReversal',
    ParticipantPaymentAccountContributionReversal = 'ParticipantPaymentAccountContributionReversal',
    PaymentAccountClientBaseRemittanceCredit = 'PaymentAccountClientBaseRemittanceCredit',
    PaymentAccountClientFeeRemittanceCredit = 'PaymentAccountClientFeeRemittanceCredit',
    PaymentAccountClientSurchargeRemittanceCredit = 'PaymentAccountClientSurchargeRemittanceCredit',
    PaymentAccountClientUnremittance = 'PaymentAccountClientUnremittance',
    PaymentAccountClientUnremittanceOfCredit = 'PaymentAccountClientUnremittanceOfCredit',
    PaymentAccountPayeeBaseRemittanceCredit = 'PaymentAccountPayeeBaseRemittanceCredit',
    PaymentAccountPayeeFeeRemittanceCredit = 'PaymentAccountPayeeFeeRemittanceCredit',
    PaymentAccountPayeeSurchargeRemittanceCredit = 'PaymentAccountPayeeSurchargeRemittanceCredit',
    PaymentAccountPayeeUnremittance = 'PaymentAccountPayeeUnremittance',
    PaymentAccountPayeeUnremittanceOfCredit = 'PaymentAccountPayeeUnremittanceOfCredit',
    PaymentPlanAdminFeeCredit = 'PaymentPlanAdminFeeCredit',
    PaymentPlanAdminSurchargeCredit = 'PaymentPlanAdminSurchargeCredit',
    PaymentPlanAdminUnremittance = 'PaymentPlanAdminUnremittance',
    PaymentPlanAdminUnremittanceOfCredit = 'PaymentPlanAdminUnremittanceOfCredit',
    PodReplenishContribution = 'PodReplenishContribution',
    PodReplenishFunding = 'PodReplenishFunding',
}

export enum FeatureAccountType {
    Advance = 'Advance',
    IAB = 'IAB',
}

export enum HideFromType {
    Client = 'Client',
    None = 'None',
    Participant = 'Participant',
    ParticipantAndClient = 'ParticipantAndClient',
}

export enum FundingPostingType {
    Budgeted = 'Budgeted',
    ContributionSchedule = 'ContributionSchedule',
    CustomMonthly = 'CustomMonthly',
    CustomOther = 'CustomOther',
    CustomQuarterly = 'CustomQuarterly',
    CustomSchedule = 'CustomSchedule',
    DeductionSchedule = 'DeductionSchedule',
    PayrollSchedule = 'PayrollSchedule',
    PointOfDisbursement = 'PointOfDisbursement',
    UserInitiated = 'UserInitiated',
}

export enum ParticipantTerminationType {
    FullCoverageWithTerminatedEmployment = 'FullCoverageWithTerminatedEmployment',
    TerminatedAfterPlanEndDate = 'TerminatedAfterPlanEndDate',
}

export enum BenefitAccountInactivationReasonType {
    InactivatedByEmployeeEligibilityClassChange = 'InactivatedByEmployeeEligibilityClassChange',
}

export enum PaymentSourceType {
    ACH = 'ACH',
    Card = 'Card',
    Check = 'Check',
    EmployerAccount = 'EmployerAccount',
    Trade = 'Trade',
    Wire = 'Wire',
}

export enum EnrollmentSourceType {
    AdminWeb = 'AdminWeb',
    ApiConnex = 'ApiConnex',
    ClientWeb = 'ClientWeb',
    File = 'File',
    ICHRAEnrollerPortal = 'ICHRAEnrollerPortal',
    ParticipantMobile = 'ParticipantMobile',
    ParticipantWeb = 'ParticipantWeb',
}

export enum PaymentStatusType {
    Paid = 'Paid',
    PartiallyPaid = 'PartiallyPaid',
    Pending = 'Pending',
    Posted = 'Posted',
    Refunded = 'Refunded',
    Returned = 'Returned',
    Reversed = 'Reversed',
    Unpaid = 'Unpaid',
}

export enum PayrollFrequencyType {
    BiWeekly24 = 'BiWeekly24',
    BiWeekly26 = 'BiWeekly26',
    Monthly = 'Monthly',
    Other = 'Other',
    SemiMonthly = 'SemiMonthly',
    Weekly = 'Weekly',
}

export enum PostingMethodType {
    ACH = 'ACH',
    ATM = 'ATM',
    Card = 'Card',
    Contribution = 'Contribution',
    ContributionReversal = 'ContributionReversal',
    Manual = 'Manual',
    Online = 'Online',
    Reimbursement = 'Reimbursement',
}

export enum PostingScheduleType {
    AnnualSchedule = 'AnnualSchedule',
    Budgeted = 'Budgeted',
    ContributionSchedule = 'ContributionSchedule',
    CustomOther = 'CustomOther',
    CustomSchedule = 'CustomSchedule',
    DeductionSchedule = 'DeductionSchedule',
    PayrollSchedule = 'PayrollSchedule',
    PointOfDisbursement = 'PointOfDisbursement',
    UserInitiated = 'UserInitiated',
}

export enum PostingStatusType {
    Error = 'Error',
    Posted = 'Posted',
    Rejected = 'Rejected',
    Reversed = 'Reversed',
    Scheduled = 'Scheduled',
}

export enum ProfileType {
    Bureau = 'Bureau',
    Client = 'Client',
    Dependent = 'Dependent',
    Individual = 'Individual',
    Instance = 'Instance',
    Payee = 'Payee',
}

export enum QualifyingLifeEvent {
    AdditionOrEliminationOfBenefitPackage = 'AdditionOrEliminationOfBenefitPackage',
    AdministrativeUseOnly = 'AdministrativeUseOnly',
    AdoptionAssistance = 'AdoptionAssistance',
    COBRA = 'COBRA',
    ChangeInCoverageOfSpouseOrDependentUnderOtherEmployersPlan = 'ChangeInCoverageOfSpouseOrDependentUnderOtherEmployersPlan',
    ChangeInDependentEligibility = 'ChangeInDependentEligibility',
    ChangeInEmploymentStatus = 'ChangeInEmploymentStatus',
    ChangeInLegalMaritalStatus = 'ChangeInLegalMaritalStatus',
    ChangeInNumberOfDependents = 'ChangeInNumberOfDependents',
    ChangeInResidence = 'ChangeInResidence',
    ChangeInTheCostOfCoverage = 'ChangeInTheCostOfCoverage',
    DependentSatisfiesOrCeasesToSatisfyEligibilityRequirements = 'DependentSatisfiesOrCeasesToSatisfyEligibilityRequirements',
    EntitlementToMedicareOrMedicaid = 'EntitlementToMedicareOrMedicaid',
    ExchangeEventExchangeEnrollmentDuringExchangeOpenOrSpecialEnrollmentPeriod = 'ExchangeEventExchangeEnrollmentDuringExchangeOpenOrSpecialEnrollmentPeriod',
    ExchangeEventReductionInHoursLessThan30 = 'ExchangeEventReductionInHoursLessThan30',
    FMLA = 'FMLA',
    HIPAASpecialEnrollmentRights = 'HIPAASpecialEnrollmentRights',
    JudgementDecreeOrOrder = 'JudgementDecreeOrOrder',
    LossOfGroupHealthCoverageSponsoredByGovernmentalOrEducationalInstitutions = 'LossOfGroupHealthCoverageSponsoredByGovernmentalOrEducationalInstitutions',
    SignificantCurtailmentOfCoverage = 'SignificantCurtailmentOfCoverage',
}

export enum AllowedRecalculationType {
    Always = 'Always',
    Never = 'Never',
    OnElectionChange = 'OnElectionChange',
}

export enum TransactionCodeSecIndicator {
    CCD = 'CCD',
    PPD = 'PPD',
    TEL = 'TEL',
    WEB = 'WEB',
}

export enum TransactionFrequencyIndicator {
    RECURRING = 'RECURRING',
    SINGLE = 'SINGLE',
}

export enum TransactionType {
    CREDIT = 'CREDIT',
    DEBIT = 'DEBIT',
}

export enum ValidElectionActivationBenefitAccountStates {
    ALOAWithBenefits = 'ALOAWithBenefits',
    ALOAWithoutBenefits = 'ALOAWithoutBenefits',
    Active = 'Active',
    ActiveNonDisbursable = 'ActiveNonDisbursable',
    GracePeriod = 'GracePeriod',
    RunOut = 'RunOut',
}

export enum TradeType {
    Buy = 'Buy',
    Sell = 'Sell',
}

export enum TradeInitiationType {
    Manual = 'Manual',
    System = 'System',
}

export enum FinancialProcessor {
    XPS1 = 'XPS1',
    XPS2 = 'XPS2',
}

export enum ChainType {
    AND = 'AND',
    OR = 'OR',
}

export enum MatchType {
    BETWEEN = 'BETWEEN',
    CONTAINS = 'CONTAINS',
    EXACT = 'EXACT',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
    IN = 'IN',
    IS_NULL = 'IS_NULL',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
    NOT = 'NOT',
    NOT_CONTAINS = 'NOT_CONTAINS',
    NOT_IN = 'NOT_IN',
    NOT_STARTS_WITH = 'NOT_STARTS_WITH',
    STARTS_WITH = 'STARTS_WITH',
}

export enum FundingSourceType {
    ClientDirect = 'ClientDirect',
    ClientToPlan = 'ClientToPlan',
    ParticipantDirect = 'ParticipantDirect',
    ParticipantToClient = 'ParticipantToClient',
}

export enum ScheduleType {
    Contribution = 'Contribution',
    Deduction = 'Deduction',
    Funding = 'Funding',
}

export enum LinkableEntryType {
    ClientBureauContribution = 'ClientBureauContribution',
    ClientContribution = 'ClientContribution',
    ClientFunding = 'ClientFunding',
    ClientFundingConversion = 'ClientFundingConversion',
    ClientNegativeFunding = 'ClientNegativeFunding',
    FundFromCAB = 'FundFromCAB',
    ParticipantBureauContribution = 'ParticipantBureauContribution',
    ParticipantContribution = 'ParticipantContribution',
    ParticipantDirectFundingConversion = 'ParticipantDirectFundingConversion',
    ParticipantToClientFunding = 'ParticipantToClientFunding',
    PayrollPosting = 'PayrollPosting',
}

export enum DisbursementEntryType {
    CDAFDisbursementToClient = 'CDAFDisbursementToClient',
    ClientRemittanceDistribution = 'ClientRemittanceDistribution',
    DisburseFromCab = 'DisburseFromCab',
    DisburseFromPayee = 'DisburseFromPayee',
    DisburseToPaymentSource = 'DisburseToPaymentSource',
    DisbursementToCharity = 'DisbursementToCharity',
    InvestmentBuyParticipant = 'InvestmentBuyParticipant',
    InvestmentSweep = 'InvestmentSweep',
    MycashThresholdDisbursement = 'MycashThresholdDisbursement',
    PayeeRemittanceDistribution = 'PayeeRemittanceDistribution',
}

export enum FundingEntryType {
    ACHConvenienceFee = 'ACHConvenienceFee',
    ClientCABFunding = 'ClientCABFunding',
    ClientFunding = 'ClientFunding',
    ClientPodFunding = 'ClientPodFunding',
    InvestmentSweep = 'InvestmentSweep',
    ParticipantAdvanceFunding = 'ParticipantAdvanceFunding',
    ParticipantDirectFunding = 'ParticipantDirectFunding',
    ParticipantPaymentGroupFunding = 'ParticipantPaymentGroupFunding',
    ParticipantToClientFunding = 'ParticipantToClientFunding',
    SellOrderFunding = 'SellOrderFunding',
    UndesignatedParticipantPaymentGroupFunding = 'UndesignatedParticipantPaymentGroupFunding',
}
